import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label } from 'reactstrap';

export default function ClientModal({ isOpen, toggle, client, allScopes, onSave }) {
  const isEdit = !!client;

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedScopes, setSelectedScopes] = useState([]);
  const [redirectUris, setRedirectUris] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setName(client ? client.name : '');
      setDescription(client ? client.description || '' : '');
      setSelectedScopes(client ? [...client.scopes] : []);
      setRedirectUris(client ? (client.redirectUris || []).join('\n') : '');
      setError(null);
    }
  }, [isOpen, client]);

  function toggleScope(scopeName) {
    setSelectedScopes((prev) =>
      prev.includes(scopeName)
        ? prev.filter((s) => s !== scopeName)
        : [...prev, scopeName]
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim()) {
      setError('Name is required.');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const uris = redirectUris.split('\n').map(u => u.trim()).filter(u => u.length > 0);
      await onSave({ name: name.trim(), description: description.trim() || null, scopes: selectedScopes, redirectUris: uris });
      toggle();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          {isEdit ? `Edit Client — ${client.name}` : 'New Client'}
        </ModalHeader>
        <ModalBody>
          {error && <div className="error-banner">{error}</div>}

          <FormGroup>
            <Label className="form-label-custom">Name *</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="my-service"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label className="form-label-custom">Description</Label>
            <Input
              type="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Optional description"
            />
          </FormGroup>

          <FormGroup>
            <Label className="form-label-custom">Redirect URIs</Label>
            <Input
              type="textarea"
              rows={3}
              value={redirectUris}
              onChange={(e) => setRedirectUris(e.target.value)}
              placeholder={"https://monapp.com/callback\nhttps://monapp.com/autre"}
              style={{ fontSize: 13, fontFamily: 'monospace' }}
            />
            <small style={{ color: '#8892a4', fontSize: 12 }}>Une URI par ligne. Requis pour le flow Authorization Code.</small>
          </FormGroup>

          <FormGroup>
            <Label className="form-label-custom">Scopes</Label>
            {allScopes.length === 0 ? (
              <p style={{ fontSize: 13, color: '#8892a4' }}>
                No scopes available. Create scopes first.
              </p>
            ) : (
              <div className="scope-check-list">
                {allScopes.map((s) => (
                  <label key={s.id} className="scope-check-item">
                    <input
                      type="checkbox"
                      checked={selectedScopes.includes(s.name)}
                      onChange={() => toggleScope(s.name)}
                    />
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{s.name}</div>
                      {s.description && (
                        <div style={{ fontSize: 12, color: '#8892a4' }}>{s.description}</div>
                      )}
                    </div>
                  </label>
                ))}
              </div>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" type="button" onClick={toggle} disabled={saving}>
            Cancel
          </Button>
          <Button className="btn-primary" type="submit" disabled={saving}>
            {saving ? 'Saving...' : isEdit ? 'Update Client' : 'Create Client'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
